export enum AutomatedAccountReceivablesManagementType {
  ACCOUNT = 'account',
  CUSTOMER = 'customer',
}
